import consumer from "./consumer"

// Subscribes to live updates for one bot: balances, profit/loss, positions
// and chart markers. `onUpdate` receives the full BotChannel payload.
// Returns the subscription; call `.unsubscribe()` to stop.
export function subscribeToBot({ botId, onUpdate }) {
  return consumer.subscriptions.create(
    { channel: "BotChannel", bot_id: botId },
    {
      received(data) {
        if (data) onUpdate(data)
      }
    }
  )
}
